import { properties } from "./properties";

export const CONSTANT = {
  CONFERENCE_ID: "{conferenceId}",
  EXTERNAL_REFERENCE_CODE: "{externalRefrenceCode}",
  DEFAULT_LANGUAGE: "en",
  OPTIONAL_SUBSCRIPTION_RADIO: "optionalSubscription",
  CONFIRM_EMAIL: "confirmEmail",
};

export const RESPONSE_STATUS = {
  SUCCESS: "SUCCESS",
  FAIL: "FAIL",
};

export const API_ENDPOINTS = {
  GET_CONFERENCE_DETAILS: `/o/c/conferences/${CONSTANT.CONFERENCE_ID}?p_auth=${properties.authToken}`,
  GET_CONFERENCE_SUBSCRIPTION: `/o/c/conferencesubscriptions/scopes/${properties.siteGroupId}?p_auth=${properties.authToken}&filter=conferenceId+eq+${CONSTANT.CONFERENCE_ID}`,
  GET_REGISTRATION_TYPE_LIST: `/o/c/registrationtypelists/scopes/${properties.siteGroupId}?p_auth=${properties.authToken}`,
  GET_CONFERENCE_DOCUMENTS: `/o/c/conferencedocumentses/scopes/${properties.siteGroupId}?p_auth=${properties.authToken}&filter=conferenceId+eq+${CONSTANT.CONFERENCE_ID}`,
  POST_PAYMENT_API: `/o/ku/payment/purchase?p_auth=${properties.authToken}`,
  ADD_CONFERENCE_REGISTRATION_API: `/o/ku/payment/add-registration?p_auth=${properties.authToken}`,
  GET_COUNTRY_LIST: `/o/headless-admin-address/v1.0/countries?p_auth=${properties.authToken}&pageSize=247`,
  GET_KU_CONFIGURATION: `/o/ku/common/configuration?p_auth=${properties.authToken}`,
  GET_PAPER_FEES_MAPPING: `/o/c/conferencenoofpaperfeesmappings/scopes/${properties.siteGroupId}?p_auth=${properties.authToken}&filter=conferenceId+eq+${CONSTANT.CONFERENCE_ID}`,
  GET_CONFERENCE_CONFIGURATION: `/o/ku/payment/conference-configuration/${CONSTANT.CONFERENCE_ID}?p_auth=${properties.authToken}`,
};

export const PL_ERC = {
  OPTIONAL_SUBSCRIPTION: "PL_Optional_Subscriptions",
  REQUIRED_SUBSCRIPTION: "PL_Required_Subscriptions",
};

export const FEE_TYPE = {
  REGISTRATION: "Registration Fees",
  OPTIONAL: "Optional Subscription Fees",
};

export const ENDPOINT_METHODS = {
  METHOD_GET: "GET",
  METHOD_POST: "POST",
  METHOD_DELETE: "DELETE",
};

export const HEADER_PARAMS = {
  CONTENT_TYPE: "Content-Type",
  APPLICATION_TYPE: "application/json",
  P_AUTH_PARAM: "&p_auth=",
};

export const ERROR_MESSAGE = {
  SOMETHING_WENT_WRONG: "something went wrong",
};

export const STRING_CONSTANT = {
  BLANK: "",
  COLON: ":",
  COMMA: ",",
  DOLLAR: "$",
  EQUAL: "=",
  SPACE: " ",
  MINUS: "-",
  QUESTION: "?",
};

export const INITIALVALUES = {
  title: "Mr.",
  firstName: STRING_CONSTANT.BLANK,
  lastName: STRING_CONSTANT.BLANK,
  userEmail: STRING_CONSTANT.BLANK,
  confirmEmail: STRING_CONSTANT.BLANK,
  mobile: STRING_CONSTANT.BLANK,
  country: STRING_CONSTANT.BLANK,
  countryCode: "+971",
  affiliation: STRING_CONSTANT.BLANK,
  registrationType: STRING_CONSTANT.BLANK,
  membershipNumber: STRING_CONSTANT.BLANK,
  authorRegistering: "no",
  isAuthor: false,
  noOfPapers: "0",
  paperReferences: STRING_CONSTANT.BLANK,
  optionalRegistration: [],
  total: 0,
};

export const FORM_TITLES = [
  { key: "Mr.", name: "Mr." },
  { key: "Ms.", name: "Ms." },
  { key: "Mrs.", name: "Mrs." },
  { key: "Dr.", name: "Dr." },
  { key: "Prof.", name: "Prof." },
];
export const FORM_COUNTRY_CODES = ["+971", "+1", "+44", "+91"];

export const IS_AUTHOR = {
  YES: "yes",
  NO: "no",
};

export const CURRENCY_TYPE = {
  AED: "aed",
  USD: "usd",
  BOTH: "both"
}
